module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "global-auth-box d-flex justify-center align-center",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "g-auth-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n    Are you sure you want to logout?\n\n    "), _c('div', {
    staticClass: "dx-flex justify-space-between gl-action"
  }, [_c('div', {
    staticClass: "op-btn btn-md btn-block btn-secodary",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('div', {
    staticClass: "op-btn btn-md btn-block btn-danger",
    on: {
      "click": _vm.proceedLogout
    }
  }, [_vm._v("Yes")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fe4d9756", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe4d9756","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/Logout.vue
// module id = 2155
// module chunks = 0